import { render } from "./RuiModal.vue?vue&type=template&id=4d59a57e&scoped=true"
import script from "./RuiModal.vue?vue&type=script&lang=ts"
export * from "./RuiModal.vue?vue&type=script&lang=ts"

import "./RuiModal.vue?vue&type=style&index=0&id=4d59a57e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4d59a57e"

export default script